"use client";

import { motion } from "framer-motion";

import charlotteBolderl from "../assets/faculty/charlotte-bolderl.jpg";
import muhammadUsamaTariq from "../assets/faculty/muhammad-usama-tariq.jpg";
import saimaAmir from "../assets/faculty/saima-amir.jpg";
import samuelAshaolu from "../assets/faculty/samuel-ashaolu.jpg";
import shebiruTilahunGossaye from "../assets/faculty/shebiru-tilahun-gossaye.jpg";
import ramaZafar from "../assets/faculty/rama-zafar1.jpg";
import ayeshaMir from "../assets/faculty/ayesha-mir.jpg";

const Faculty = () => {
	return (
		<div className="bg-white pt-20">
			{/* Hero Section */}
			<section className="relative py-20 bg-[#819f3d] text-white">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.h1
						initial={{ y: -20, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						transition={{ duration: 0.8 }}
						className="text-4xl md:text-5xl font-bold text-center mb-6">
						Council Members
					</motion.h1>
				</div>
			</section>

			{/* Faculty Profiles */}
			<section className="py-16">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={muhammadUsamaTariq}
								alt="Muhammad Usama Tariq image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Muhammad Usama Tariq
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									Pakistan
								</p>
							</div>
						</motion.div>

						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={ayeshaMir}
								alt="Ayesha Mir image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Ayesha Mir
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									Australia
								</p>
								{/* <p className="text-gray-600">Council member SLD</p> */}
							</div>
						</motion.div>

						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={shebiruTilahunGossaye}
								alt="Shebiru Tilahun Gossaye image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Shebiru Tilahun Gossaye
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									Ethopia
								</p>
								{/* <p className="text-gray-600">Council member SLD</p> */}
							</div>
						</motion.div>

						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={saimaAmir}
								alt="Saima Amir image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Saima Amir
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									Australia
								</p>
								{/* <p className="text-gray-600">Council member</p> */}
							</div>
						</motion.div>

						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={samuelAshaolu}
								alt="Samuel Ashaolu image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Samuel Ashaolu
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									USA
								</p>
								{/* <p className="text-gray-600">Council member</p> */}
							</div>
						</motion.div>

						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={charlotteBolderl}
								alt="Charlotte Bolder image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Charlotte Bölderl
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									Austria
								</p>
								{/*
								<p className="text-gray-600">
									
								</p> */}
							</div>
						</motion.div>

						<motion.div
							initial={{ y: 50, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							transition={{ duration: 0.8 }}
							className="bg-white p-8 rounded-lg shadow-lg flex flex-col md:flex-row gap-6">
							<img
								src={ramaZafar}
								alt="Rama Zafar image"
								className="w-32 h-32 rounded-full object-cover mx-auto md:mx-0"
							/>
							<div>
								<h2 className="text-2xl font-bold text-[#1666ba] mb-2 text-center md:text-left">
									Rama Zafar
								</h2>
								<p className="text-gray-700 font-medium mb-4 text-center md:text-left">
									Pakistan
								</p>
								{/*
								<p className="text-gray-600">
									
								</p> */}
							</div>
						</motion.div>
					</div>
				</div>
			</section>

			{/* Research Interests */}
			<section className="py-16 bg-gray-50">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<motion.h2
						initial={{ opacity: 0 }}
						whileInView={{ opacity: 1 }}
						transition={{ duration: 0.8 }}
						className="text-3xl font-bold text-center text-[#1666ba] mb-12">
						Research Areas
					</motion.h2>
					<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
						{[
							{
								title: "Conflict Resolution",
								description:
									"Exploring innovative approaches to resolving international disputes",
								icon: "🕊️",
							},
							{
								title: "Leadership Development",
								description:
									"Researching effective methods for cultivating global leaders",
								icon: "📈",
							},
							{
								title: "International Relations",
								description:
									"Analyzing emerging patterns in global diplomacy and cooperation",
								icon: "🌐",
							},
						].map((area, index) => (
							<motion.div
								key={index}
								initial={{ y: 50, opacity: 0 }}
								whileInView={{ y: 0, opacity: 1 }}
								transition={{ duration: 0.8, delay: index * 0.2 }}
								className="bg-white p-6 rounded-lg shadow-lg text-center">
								<div className="text-4xl mb-4">{area.icon}</div>
								<h3 className="text-xl font-semibold text-[#1666ba] mb-2">
									{area.title}
								</h3>
								<p className="text-gray-600">{area.description}</p>
							</motion.div>
						))}
					</div>
				</div>
			</section>
		</div>
	);
};

export default Faculty;
